import React from 'react';
import { Translations } from '../types/language';

interface Props {
  translations: Translations;
}

export function Logo({ translations }: Props) {
  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="bg-white p-6 rounded-xl shadow-sm">
        <img 
          src="https://assets.zyrosite.com/dOqyD8v2laFZNJEy/amg-batiment-logo-YanyX4Jg07cJaZ7Z.webp"
          alt="AMG Batiment Logo" 
          className="h-32 w-auto object-contain"
        />
      </div>
      <div className="space-y-2">
        <h1 className="text-4xl font-bold text-gray-900">
          {translations.title}
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          {translations.subtitle}
        </p>
      </div>
    </div>
  );
}